import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import React, { Children } from 'react';
import Spinner from '../../atoms/spinner';
const Button = React.forwardRef(({ variant = 'primary', size = 'large', loading = false, children, active = false, ...attributes }, ref) => {
    const handleClick = (e) => {
        if (!loading && attributes.onClick) {
            attributes.onClick(e);
        }
    };
    const variantClassname = clsx({
        ['btn-primary']: variant === 'primary',
        ['btn-secondary']: variant === 'secondary',
        ['btn-ghost']: variant === 'ghost',
        ['btn-danger']: variant === 'danger',
        ['btn-nuclear']: variant === 'nuclear',
        ['btn-outline']: variant === 'outline',
        ['btn-teal']: variant === 'teal',
        ['btn-teal-active']: variant === 'teal' && active,
    });
    const sizeClassname = clsx({
        ['btn-large']: size === 'large',
        ['btn-medium']: size === 'medium',
        ['btn-small']: size === 'small',
    });
    return (_jsx("button", { ...attributes, className: clsx('btn', variantClassname, sizeClassname, attributes.className), disabled: attributes.disabled || loading, ref: ref, onClick: handleClick, children: loading ? (_jsx(Spinner, { size: size, variant: 'secondary' })) : (Children.map(children, (child, i) => {
            return (_jsx("span", { className: "mr-xsmall last:mr-0", children: child }, i));
        })) }));
});
export default Button;
//# sourceMappingURL=index.js.map